// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginInfo_root__31cxX","name":"LoginInfo_name__5_Sv6","logout":"LoginInfo_logout__1dDnc"};